<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'company.upload_document' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form [formGroup]="metadataDocumentForm">
    <ion-grid class="ion-no-padding">
      <ion-row class="ion-padding-bottom">
        <ion-col size="12">
          <h2 class="ion-margin-top-0">{{ 'documentType.' + documentType | translate }}</h2>
        </ion-col>

        <ion-col size="12">
          <lib-file-drop-area
            [acceptFormats]="'image/jpeg,application/pdf'"
            (fileToParentComponent)="uploadCompanyDocumentAsFile($event)"
            [hideButton]="true"
          ></lib-file-drop-area>
        </ion-col>

        <ion-col size="12">
          <div class="ion-padding-vertical">
            @if (documentType === EDocumentType.BANK_OWNERSHIP_CERTIFICATE) {
              <ion-input
                formControlName="iban"
                name="iban"
                type="text"
                label="{{ 'company.iban' | translate }}"
                placeholder="{{ 'company.iban' | translate }}"
                fill="outline"
                labelPlacement="floating"
                (ionInput)="filterInputIban($event)"
                helperText="{{ 'company.enter_account_number' | translate }}"
                errorText="{{ 'company.enter_account_error' | translate }}"
              ></ion-input>
            }
            @if (documentType === EDocumentType.GOODS_ASSURANCE) {
              <ion-input
                formControlName="assuranceQuantity"
                name="assuranceQuantity"
                type="number"
                label="{{ 'company.assurance_quantity' | translate }}"
                placeholder="{{ 'company.assurance_quantity' | translate }}"
                fill="outline"
                labelPlacement="floating"
                helperText="{{ 'company.enter_assurance_quantity' | translate }}"
                errorText="{{ 'company.enter_assurance_quantity_error' | translate }}"
              ></ion-input>
            }

            @if (
              documentType === EDocumentType.SOCIAL_SECURITY_PAYMENT_CERTIFICATE ||
              documentType === EDocumentType.TAX_AUTHORITIES_PAYMENT_CERTIFICATE ||
              documentType === EDocumentType.EUROPEAN_LICENSE ||
              documentType === EDocumentType.GOODS_ASSURANCE ||
              documentType === EDocumentType.CIVIL_RESPONSABILITY_ASSURANCE
            ) {
              <ion-input
                formControlName="expirationDate"
                name="expirationDate"
                type="date"
                label="{{ 'company.expiration_date' | translate }}"
                placeholder="{{ 'company.expiration_date' | translate }}"
                fill="outline"
                labelPlacement="floating"
                [helperText]="expirationText"
                [errorText]="expirationTextError"
              ></ion-input>
            }
          </div>
        </ion-col>

        @if (errorMessage()) {
          <ion-col size="12">
            <div class="errors">
              {{ errorMessage() }}
            </div>
          </ion-col>
        }
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            {{ 'general.save' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
